export const booleanExpressionsAvailableInQueryBuilder = [
    'EQ',
    'NEQ',
    'GT',
    'LT',
    'GTE',
    'LTE',
    'BETWEEN',
    'CONTAINS',
    'STARTS_WITH',
    'ENDS_WITH',
    'IS_HOLIDAY',
    'IS_WORKDAY',
    'IN',
];
